export default "__VITE_ASSET__$n$B4m_l__"